import { render, staticRenderFns } from "./TourAttentionAlert.vue?vue&type=template&id=fb68e170&scoped=true"
import script from "./TourAttentionAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./TourAttentionAlert.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TourAttentionAlert.vue?vue&type=style&index=0&id=fb68e170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb68e170",
  null
  
)

export default component.exports